import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import VisitorTracker from './components/VisitorTracker';
import FloatingContactButtons from './components/FloatingContactButtons';
import Home from './pages/Home';
import Cars from './pages/Cars';
import CarDetail from './pages/CarDetail';
import Tours from './pages/Tours';
import TourDetail from './pages/TourDetail';
import Contact from './pages/Contact';
import InquirySuccess from './pages/InquirySuccess';
import About from './pages/About';

// Admin imports
import AdminLogin from './pages/Admin/AdminLogin';
import AdminLayout from './pages/Admin/AdminLayout';
import AdminDashboard from './pages/Admin/AdminDashboard';
import AdminCars from './pages/Admin/AdminCars';
import AdminTours from './pages/Admin/AdminTours';
import AdminInquiries from './pages/Admin/AdminInquiries';
import AdminContacts from './pages/Admin/AdminContacts';
import AdminSettings from './pages/Admin/AdminSettings';
import AdminAnalytics from './pages/Admin/AdminAnalytics';
import AdminTeam from './pages/Admin/AdminTeam';
import AdminHeroSlides from './pages/Admin/AdminHeroSlides';

// Main Website Layout Component
const MainLayout = ({ children }) => (
  <div className="min-h-screen flex flex-col">
    <Navbar />
    <main className="flex-grow">
      {children}
    </main>
    <Footer />
    <FloatingContactButtons />
  </div>
);

function App() {
  return (
    <Router>
      <VisitorTracker />
      <Routes>
        {/* Public Routes with Website Layout */}
        <Route path="/" element={
          <MainLayout>
            <Home />
          </MainLayout>
        } />
        <Route path="/cars" element={
          <MainLayout>
            <Cars />
          </MainLayout>
        } />
        <Route path="/cars/:id" element={
          <MainLayout>
            <CarDetail />
          </MainLayout>
        } />
        <Route path="/tours" element={
          <MainLayout>
            <Tours />
          </MainLayout>
        } />
        <Route path="/tours/:id" element={
          <MainLayout>
            <TourDetail />
          </MainLayout>
        } />
        <Route path="/contact" element={
          <MainLayout>
            <Contact />
          </MainLayout>
        } />
        <Route path="/inquiry-success" element={
          <MainLayout>
            <InquirySuccess />
          </MainLayout>
        } />
        <Route path="/about" element={
  <MainLayout>
    <About />
  </MainLayout>
} />
        {/* Admin Routes - No Navbar/Footer (optional: you can add floating buttons here too) */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="analytics" element={<AdminAnalytics />} />
          <Route path="cars" element={<AdminCars />} />
          <Route path="tours" element={<AdminTours />} />
          <Route path="team" element={<AdminTeam />} />
          <Route path="hero-slides" element={<AdminHeroSlides />} />
          <Route path="inquiries" element={<AdminInquiries />} />
          <Route path="contacts" element={<AdminContacts />} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;